import createAdvancedSearchPageStorage from "./factory";
import advancedSearchPageStorageProvider from "./provider";

const advancedSearchPageStorage = createAdvancedSearchPageStorage(advancedSearchPageStorageProvider);

export default advancedSearchPageStorage;
